// extracted by mini-css-extract-plugin
export default {"qr":"Qr_qr__0UoqF"};